import React from "react";
import { motion } from "framer-motion";

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`eyebrow ${className}`}>{children}</span>
);

export const GlassCard = ({ children, className = "", hover = true, ...props }) => (
  <div className={`glass rounded-2xl ${hover ? "glass-hover" : ""} ${className}`} {...props}>
    {children}
  </div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, center = false, className = "" }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
      {title}
    </h2>
    {subtitle && <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">{subtitle}</p>}
  </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Section = ({ children, className = "", ...props }) => (
  <section className={`py-16 sm:py-24 lg:py-28 ${className}`} {...props}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{children}</div>
  </section>
);
